import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function MobileListCard({
  title,
  subtitle,
  leading,
  status,
  fields = [],
  footer,
  actions,
  onClick,
}) {
  return (
    <Card
      variant="outlined"
      onClick={onClick}
      sx={{
        ...(onClick && {
          cursor: "pointer",
          transition: "border-color 0.15s, box-shadow 0.15s",
          "&:hover": { borderColor: "primary.main", boxShadow: 1 },
          "&:active": { bgcolor: "action.hover" },
        }),
      }}
    >
      <CardContent sx={{ pb: "12px !important" }}>
        <Stack direction="row" spacing={1.5} alignItems="flex-start">
          {leading}
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={1}
            >
              <Box sx={{ minWidth: 0 }}>
                <Typography
                  variant="subtitle2"
                  fontWeight={700}
                  color="primary.main"
                  noWrap
                >
                  {title}
                </Typography>
                {subtitle && (
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    display="block"
                    noWrap
                  >
                    {subtitle}
                  </Typography>
                )}
              </Box>
              {status}
            </Stack>

            {fields.length > 0 && (
              <Stack spacing={0.5} sx={{ mt: 1 }}>
                {fields.map((field, index) => (
                  <Stack
                    key={field.label || index}
                    direction="row"
                    justifyContent="space-between"
                    spacing={1}
                  >
                    {field.label && (
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ flexShrink: 0 }}
                      >
                        {field.label}
                      </Typography>
                    )}
                    <Typography
                      variant="body2"
                      component="span"
                      sx={{ textAlign: field.label ? "right" : "left" }}
                    >
                      {field.value}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            )}

            {(footer || actions) && (
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mt: 1.5 }}
              >
                <Box>{footer}</Box>
                {actions && (
                  <Box onClick={(e) => e.stopPropagation()}>{actions}</Box>
                )}
              </Stack>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
}

export function MobileListCardSkeleton({ height = 120 }) {
  return <Skeleton variant="rounded" height={height} animation="wave" />;
}

MobileListCard.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  leading: PropTypes.node,
  status: PropTypes.node,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.node,
    })
  ),
  footer: PropTypes.node,
  actions: PropTypes.node,
  onClick: PropTypes.func,
};

MobileListCardSkeleton.propTypes = {
  height: PropTypes.number,
};
